import i18n from "@/plugins/vue-i18n";

import Survey from "@/views/settings/survey/index/index.vue";
import SurveyAdd from "@/views/settings/survey/add/index.vue";
import SurveyEdit from "@/views/settings/survey/edit/index.vue";

const survey = [
  {
    path: "settings/settings-survey",
    name: "SettingsSurvey",
    component: Survey,
    meta: {
      title: i18n.t("title.survey._"),
    },
  },
  {
    path: "settings/settings-survey/add",
    name: "SurveyAdd",
    component: SurveyAdd,
    meta: {
      title: i18n.t("title.survey.add"),
    },
  },
  {
    path: "settings/settings-survey/:id/edit",
    name: "SurveyEdit",
    component: SurveyEdit,
    meta: {
      title: i18n.t("title.survey.edit"),
    },
  },
];

export default survey;
